export class CMProfileInterest {

    public name: string;
    protected _id: string;
    protected _idRef: number;

    public constructor() {
        this._id = '';
        this._idRef = -1;
        this.name = '';
    }

    public fromRaw(data: IProfileInterestData): CMProfileInterest {
        this._id = data._id || '';
        this._idRef = data._idRef || -1;
        this.name = data.name || '';
        return this;
    }

    public toDbObject(): any {
        let props: any = {};
        props = Object.assign(props, this);
        props._type = this.constructor.name;
        return props;
    }

    public get id() {
        return this._id;
    }

    public get refId() {
        return this._idRef;
    }

}

export interface IProfileInterestData {
    _id?: string;
    _idRef: number;
    name: string;
}